import { alpha } from '@mui/material/styles'

const styles = {
  content: ({ isFlagged, overlay } = {}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    padding: 2,
    cursor: overlay ? 'grabbing' : 'inherit',
    ...(overlay
      ? {
          backgroundColor: (theme) => (isFlagged ? alpha(theme.palette.warning.lighter, 0.7) : alpha(theme.palette.background.paper, 0.6)),
          backdropFilter: 'blur(10px) saturate(180%)',
          WebkitBackdropFilter: 'blur(10px) saturate(180%)',
          boxShadow: (theme) =>
            `0 16px 36px -10px ${alpha(theme.palette.common.black, 0.35)}, inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.5)}`,
          transform: 'rotate(-1.5deg)',
        }
      : {
          backgroundColor: (theme) => (isFlagged ? theme.palette.warning.lighter : theme.palette.background.paper),
          boxShadow: (theme) => theme.shadows[1],
        }),
  }),
  errorCard: {
    outline: '1px solid',
    outlineColor: 'error.main',
  },
  warningCard: {
    outline: '1px solid',
    outlineColor: 'warning.main',
  },
}

export default styles
